import React from 'react';
import styled from 'styled-components';

export default styled.div`
  font-size: 18px;
  line-height: ${28/18};
`
